module.exports = __webpack_public_path__ + "static/media/class_1.8cdfcab2.svg";